import React from 'react'

let ImageViewer = null

const DeferredImageViewer = (props) => {
  const setLoadingDependencies = React.useState(true)[1]

  React.useEffect(() => {
    import('./ImageViewer')
      .then((imageViewer) => {
        ImageViewer = imageViewer.ImageViewer
        setLoadingDependencies(false)
      })
      .catch((e) => {
        console.error(e)
      })
  }, [])

  if (!ImageViewer) {
    return null
  } else {
    return <ImageViewer {...props} />
  }
}

export default DeferredImageViewer
